import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    name: "guest",
    path: "/login",
    component: () => import("../components/layouts/Guest.vue"),
    meta: {
      middleware: "guest",
    },
    children: [
      {
        path: "",
        name: "login",
        component: () =>
          import(/*webpackChunck: "login" */ "../pages/Auth/LoginView.vue"),
        meta: {
          title: `Log In`,
        },
      },
      {
        path: "/reset-password",
        name: "reset-password",
        component: () =>
          import(
            /*webpackChunck: "resetpassword" */ "../pages/Auth/ResetPasswordView.vue"
          ),
        meta: {
          title: `Log In`,
        },
      },
      {
        path: "/pagenotfound",
        name: "pagesnotfound",
        component: () => import("../components/404NotFound.vue"),
      },
    ],
  },
  {
    name: "base",
    path: "/",
    component: () => import("../components/layouts/Default.vue"),
    meta: {
      middleware: "auth",
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        redirect: { name: "home" },
      },
      {
        path: "/dashboard",
        name: "home",
        component: () =>
          import(/* webpackChunkName: "dashboard" */ "../pages/HomeView.vue"),
        meta: {
          title: `Dashboard`,
        },
      },
      {
        path: "subscribers-list",
        name: "subscriberLists",
        component: () =>
          import(
            /* webpackChunkName: "subscriberlist" */ "../pages/Subscribers/Subscriber/SubscriberListView.vue"
          ),
        meta: {
          title: `subsciber list`,
        },
      },
      {
        path: "connected-users",
        name: "connectedusers",
        component: () =>
          import(
            /* webpackChunkName: "subscriberusers" */ "../pages/Subscribers/ConnectedUser/ConnectedUserView.vue"
          ),
        meta: {
          title: `connected user`,
        },
      },
      {
        path: "add-single-subscriber",
        name: "addsinglesubscriber",
        component: () =>
          import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/Subscribers/Subscriber/AddSingleSubscriber.vue"
          ),
        meta: {
          title: `Add Single Subscriber`,
        },
      },
      {
        path: "edit-single-subscriber/:id",
        name: "editsinglesubscriber",
        component: () =>
          import(
            /* webpackChunkName: "EditSingleSubscriber" */ "../pages/Subscribers/Subscriber/EditSingleSubscriber.vue"
          ),
        meta: {
          title: `Edit Single Subscriber`,
        },
      },
      {
        path: "subscribers-list/:id",
        name: "PinListBatchWises",
        component: () =>
          import(
            /* webpackChunkName: "subscriber" */ "../pages/Subscribers/Subscriber/SubscriberListView.vue"
          ),
        meta: {
          title: `Subsciber List`,
        },
      },
      {
        path: "ip-lists",
        name: "iplists",
        component: () =>
          import(
            /* webpackChunkName: "AddSingleSubscriber" */ "../pages/VpnServer/IpList.vue"
          ),
        meta: {
          title: `Ip List`,
        },
      },
      {
        path: "add-ip",
        name: "addip",
        component: () =>
          import(
            /* webpackChunkName: "Addip" */ "../pages/VpnServer/AddIp.vue"
          ),
        meta: {
          title: `Add Ip`,
        },
      },
      {
        path: "edit-ip/:id",
        name: "editip",
        component: () =>
          import(
            /* webpackChunkName: "editIp" */ "../pages/VpnServer/EditIp.vue"
          ),
        meta: {
          title: `Edit Ip`,
        },
      },
      {
        path: "ip-bundle-lists",
        name: "ipbundlelists",
        component: () =>
          import(
            /* webpackChunkName: "ipbundlelists" */ "../pages/IpBundle/IpBundleList.vue"
          ),
        meta: {
          title: `ip bundle list`,
        },
      },
      {
        path: "add-ip-bundle",
        name: "addipbundle",
        component: () =>
          import(
            /* webpackChunkName: "addipbundle" */ "../pages/IpBundle/AddIpBundle.vue"
          ),
        meta: {
          title: `Add New ip bundle`,
        },
      },
      {
        path: "edit-ip-bundle/:id",
        name: "editipbundle",
        component: () =>
          import(
            /* webpackChunkName: "editipbundle" */ "../pages/IpBundle/AddIpBundle.vue"
          ),
        meta: {
          title: `ip bundle list`,
        },
      },
      {
        path: "ip-bundle-details-lists/:id",
        name: "IpBundleDtlsLists",
        component: () =>
          import(
            /* webpackChunkName: "IpBundleDtlsLists" */ "../pages/IpBundle/IpBundleDtlsList.vue"
          ),
        meta: {
          title: `ip bundle list`,
        },
      },
      {
        path: "add-server",
        name: "addserver",
        component: () =>
          import(
            /* webpackChunkName: "addserver" */ "../pages/Server/AddServer.vue"
          ),
        meta: {
          title: `Add Server`,
        },
      },
      {
        path: "edit-server/:id",
        name: "editserver",
        component: () =>
          import(
            /* webpackChunkName: "editserver" */ "../pages/Server/EditServer.vue"
          ),
        meta: {
          title: `Add Server`,
        },
      },
      {
        path: "server-lists",
        name: "serverlists",
        component: () =>
          import(
            /* webpackChunkName: "serverlists" */ "../pages/Server/ServerLists.vue"
          ),
        meta: {
          title: `Server List`,
        },
      },
      {
        path: "app-lists",
        name: "applists",
        component: () =>
          import(
            /* webpackChunkName: "applists" */ "../pages/PushManagement/AppList.vue"
          ),
        meta: {
          title: `App List`,
        },
      },
      {
        path: "add-app",
        name: "addapp",
        component: () =>
          import(
            /* webpackChunkName: "addapp" */ "../pages/PushManagement/AddApps.vue"
          ),
        meta: {
          title: `Add App`,
        },
      },
      {
        path: "edit-app/:id",
        name: "ediapp",
        component: () =>
          import(
            /* webpackChunkName: "ediapp" */ "../pages/PushManagement/AddApps.vue"
          ),
        meta: {
          title: `Edit App`,
        },
      },
      {
        path: "template-lists",
        name: "templatelists",
        component: () =>
          import(
            /* webpackChunkName: "templatelists" */ "../pages/PushManagement/TemplateList.vue"
          ),
        meta: {
          title: `Template List`,
        },
      },
      {
        path: "add-template",
        name: "addtemplate",
        component: () =>
          import(
            /* webpackChunkName: "addtemplate" */ "../pages/PushManagement/AddTemplate.vue"
          ),
        meta: {
          title: `Add Template`,
        },
      },
      {
        path: "edit-template/:id",
        name: "editemplate",
        component: () =>
          import(
            /* webpackChunkName: "editemplate" */ "../pages/PushManagement/AddTemplate.vue"
          ),
        meta: {
          title: `Edit Template`,
        },
      },
      {
        path: "all-push-requests",
        name: "allpushrequests",
        component: () =>
          import(
            /* webpackChunkName: "AllPushRequests" */ "../pages/PushManagement/AllPushRequestList.vue"
          ),
        meta: {
          title: `All Push Requests`,
        },
      },
      {
        path: "send-new-push",
        name: "sentnewpush",
        component: () =>
          import(
            /* webpackChunkName: "SentNewPush" */ "../pages/PushManagement/SentNewPush.vue"
          ),
        meta: {
          title: `Sent New Push`,
        },
      },
      {
        path: "/install-vpn-server/:id",
        name: "installovpns",
        component: () =>
          import(
            /* webpackChunkName: "installovpns" */ "../pages/Server/InstallOvpn.vue"
          ),
        meta: {
          title: `Vpn Install`,
        },
      },
      {
        path: "add-rateplan",
        name: "addrateplans",
        component: () =>
          import(
            /* webpackChunkName: "addrateplans" */ "../pages/RatePlan/AddRatePlan.vue"
          ),
        meta: {
          title: `Add Rateplan`,
        },
      },
      {
        path: "rateplan-lists",
        name: "rateplanlists",
        component: () =>
          import(
            /* webpackChunkName: "rateplanlists" */ "../pages/RatePlan/RatePlan.vue"
          ),
        meta: {
          title: `Rateplan List`,
        },
      },
      {
        path: "/edit-rateplans/:id",
        name: "editrateplan",
        component: () =>
          import(
            /* webpackChunkName: "editrateplan" */ "../pages/RatePlan/EditRatePlan.vue"
          ),
        meta: {
          title: `Edit Rateplan`,
        },
      },
      {
        path: "/rateplans/:id",
        name: "saleingrateplans",
        component: () =>
          import(
            /* webpackChunkName: "saleingrateplans" */ "../pages/RatePlan/SaleingRatePlan.vue"
          ),
        meta: {
          title: `Saleing Rateplan`,
        },
      },
      {
        path: "/add-sale-rate/:id",
        name: "addsalerate",
        component: () =>
          import(
            /* webpackChunkName: "addsalerate" */ "../pages/RatePlan/AddSaleRate.vue"
          ),
        meta: {
          title: `Saleing Rateplan`,
        },
      },
      {
        path: "/edit-sale-rate/:id",
        name: "editsalerates",
        component: () =>
          import(
            /* webpackChunkName: "editsalerates" */ "../pages/RatePlan/EditSaleRate.vue"
          ),
        meta: {
          title: `Saleing Rateplan`,
        },
      },
      {
        path: "subscriber-subscription-report",
        name: "subscribersubscriptionreport",
        component: () =>
          import(
            /* webpackChunkName: "subscribersubscriptionreport" */ "../pages/Report/SubscriberSubscriptionReport.vue"
          ),
        meta: {
          title: `Subscription Report`,
        },
      },

      {
        path: "hourly-subscription-report",
        name: "hourlysubscriptionreport",
        component: () =>
          import(
            /* webpackChunkName: "hourlysubscriptionreport" */ "../pages/Report/HourlySubscriptionReport.vue"
          ),
        meta: {
          title: `Hourly Subscription Report`,
        },
      },
      {
        path: "online-transaction-report",
        name: "onlinetransactionreport",
        component: () =>
          import(
            /* webpackChunkName: "OnlineTransactionReport" */ "../pages/Report/OnlineTransactionReport.vue"
          ),
        meta: {
          title: `Online Transaction Report`,
        },
      },
       {
        path: "radius-auth-server",
        name: "radiusserver",
        component: () =>
          import(
            /* webpackChunkName: "radiusserver" */ "../pages/Settings/RadiusServer.vue"
          ),
        meta: {
          title: `Radius Auth Server List`,
        },
      },
      {
        path: "add-add-radius-auth-server",
        name: "addnewradiusserver",
        component: () =>
          import(
            /* webpackChunkName: "addnewradiusserver" */ "../pages/Settings/AddRadiusServer.vue"
          ),
        meta: {
          title: `Add New Radius Server`,
        },
      },
      {
        path: "/edit-radius-auth-server/:id",
        name: "EditRadiusAuth",
        component: () =>
          import(
            /* webpackChunkName: "EditRadiusAuth" */ "../pages/Settings/AddRadiusServer.vue"
          ),
        meta: {
          title: `Edit Radius Auth Server`,
        },
      },
      {
        path: "/install-auth-server/:id",
        name: "InstallAuth",
        component: () =>
          import(
            /* webpackChunkName: "InstallAuth" */ "../pages/Settings/InstallAuthServer.vue"
          ),
        meta: {
          title: `Install Auth Server`,
        },
      },
      {
        path: "config-settings",
        name: "addconfigsettings",
        component: () =>
          import(
            /* webpackChunkName: "addconfigsettings" */ "../pages/Settings/AddConfigSetting.vue"
          ),
        meta: {
          title: `Settings`,
        },
      },
      {
        path: "updateadminprofile",
        name: "adminprofile",
        component: () =>
          import(
            /* webpackChunkName: "adminprofile" */ "../pages/Settings/AdminProfileView.vue"
          ),
        meta: {
          title: `Settings`,
        },
      },
      {
        path: "panel-settings",
        name: "addpanelsettings",
        component: () =>
          import(
            /* webpackChunkName: "addpanelsettings" */ "../pages/Settings/AddPanelSetting.vue"
          ),
        meta: {
          title: `Settings`,
        },
      },


      {
        path: "banner-lists",
        name: "bannerlists",
        component: () =>
          import(
            /* webpackChunkName: "bannerLists" */ "../pages/Banner/BannerList.vue"
          ),
        meta: {
          title: `Banner List`,
        },
      },

      {
        path: "add-banner",
        name: "addbanner",
        component: () =>
          import(
            /* webpackChunkName: "addBanner" */ "../pages/Banner/AddBanner.vue"
          ),
        meta: {
          title: `Add Banner`,
        },
      },
    {
        path: "edit-banner/:id",
        name: "editbanner",
        component: () =>
          import(
            /* webpackChunkName: "addBanner" */ "../pages/Banner/EditBanner.vue"
          ),
        meta: {
          title: `Edit Banner`,
        },
      },
      

    ],
  },
];

const router = createRouter({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

function isAuthenticated() {
  const token = localStorage.getItem("jwt_token");
  return !!(token && token !== "null" && token !== "undefined");
}

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const authenticated = isAuthenticated();

  if (requiresAuth && !authenticated) {
    next({ name: "login", query: { redirect: to.fullPath } });
    return;
  }

  if ((to.name === "login" || to.path === "/") && authenticated) {
    next({ name: "home" });
    return;
  }

  if (!to.matched.length) {
    next({ name: authenticated ? "home" : "login" });
    return;
  }

  next();
});

export default router;
